import React from 'react'

type Props = {
  enabled: boolean
  onDragStart: (e: React.DragEvent<HTMLSpanElement>) => void
  onDragEnd: () => void
  /** Shown when `enabled`; explains that dragging reorders. */
  title: string
  className?: string
}

/**
 * Six-dot grip: drag only starts from this control (not the whole row/card).
 */
export function WheelManagementDragHandle({
  enabled,
  onDragStart,
  onDragEnd,
  title,
  className = '',
}: Props) {
  return (
    <span
      className={`gw-wm__drag-handle${enabled ? '' : ' gw-wm__drag-handle--disabled'}${className ? ` ${className}` : ''}`}
      draggable={enabled}
      onDragStart={e => {
        if (!enabled) {
          e.preventDefault()
          return
        }
        onDragStart(e)
      }}
      onDragEnd={() => onDragEnd()}
      title={enabled ? title : undefined}
      role={enabled ? 'img' : undefined}
      aria-label={enabled ? title : undefined}
      aria-hidden={!enabled}
    >
      <span className="gw-wm__drag-handle__dots">
        {Array.from({ length: 6 }, (_, i) => (
          <span key={i} className="gw-wm__drag-handle__dot" />
        ))}
      </span>
    </span>
  )
}
